export default {
  GUEST: 'guest',
  SUPPLIER: 'supplier',
  CAPSTEERING: 'cap-steering',
  CAPTEAM: 'cap-team',
  DDMSTEAM: 'ddms-team'
}
